import { IMG } from './data';

const RATIO = { full: 1089 / 419, compact: 1089 / 388 };

export const ErneLogo = ({ dark = false, compact = false, className = '', testId = 'erne-logo' }) => {
  const src = compact ? IMG.logoCompact : IMG.logo;
  const style = { aspectRatio: RATIO[compact ? 'compact' : 'full'], '--erne-mask': `url(${src})`, '--erne-ink': dark ? '#FFFFFF' : '#090A0C' };
  return (
    <span role="img" aria-label="The Erne — Take the leap" data-testid={testId} className={`erne-logo relative block select-none ${className}`} style={style}>
      <span className="erne-logo-ink" aria-hidden />
    </span>
  );
};
